import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { showModal } from "../../../../redux/actions/modal";
import ButtonLoader from "../../../../UI/Loaders/Loaders";
import { handleSwalErrorAlert } from "../../../../helpers";
import { errorHandler } from "../../../../helpers/errorHandler";
import useInvestmentCertificate from "../hooks/useInvestmentCertificate";

interface IViewCertificateModalProps {
  dataRecord: {
    investmentId: number;
    currency: string;
    customerEmail?: string;
  };
  onCloseModal: () => void;
}

const ViewInvestmentCertificateModal = ({
  dataRecord,
  onCloseModal,
}: IViewCertificateModalProps) => {
  const dispatch = useDispatch();

  const {
    data: certificateData,
    isLoading,
    isError,
    error,
  } = useInvestmentCertificate(dataRecord.investmentId);

  const certificateUrl =
    certificateData?.data?.certificateUrl || certificateData?.data?.url || "";

  useEffect(() => {
    if (isError) {
      const errorMessage = errorHandler(error);
      handleSwalErrorAlert(errorMessage);
      onCloseModal();
    }
  }, [isError, error, onCloseModal]);

  const handleSendCertificate = () => {
    dispatch(
      showModal({
        modalIdentifier: "sendinvestmentcertificate",
        dataRecord: {
          investmentId: dataRecord.investmentId,
          currency: dataRecord.currency,
          customerEmail: dataRecord.customerEmail || "",
        },
      }),
    );
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="Modal__content" style={{ overflow: "hidden" }}>
        <div className="Modal__body">
          <React.Fragment>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="Modal__title mb-0">Investment Certificate</h3>
              <div className="d-flex ">
                <Button
                  className="mr-2"
                  type="primary"
                  size="large"
                  onClick={handleSendCertificate}
                  disabled={isLoading || !certificateUrl}
                >
                  <i className="fa fa-paper-plane" /> Send Certificate
                </Button>
                <Button size="large" onClick={onCloseModal}>
                  <i className="fa fa-times" /> Close
                </Button>
              </div>
            </div>

            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "500px" }}
              >
                <ButtonLoader />
              </div>
            ) : certificateUrl ? (
              <div style={{ minHeight: "600px", height: "70vh" }}>
                <iframe
                  src={certificateUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                  }}
                  title="Investment Certificate"
                />
              </div>
            ) : (
              <div
                className="alert alert-warning text-center"
                style={{ minHeight: "200px", paddingTop: "80px" }}
              >
                <i className="fa fa-exclamation-triangle fa-3x mb-3" />
                <p>No certificate available to display</p>
              </div>
            )}
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default ViewInvestmentCertificateModal;
